import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

export const ModalWrapper = styled.div`
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    .card--modal {
      padding: 20px;
      height: ${( { height } ) => height ? height : ''};
      /*codigo para fazer efeito do modal surgir de cima para baixo */
      /* bottom: 0; */
      /* top: auto; */
      width: 100%;
      /* -webkit-transform: translate(0); */
      /* transform: translate(0); */
      /* left: 0; */
      & > div {
        padding: 0 !important;
      }
    }
    /* section {
      transform: ${props => props.open ? `translateY(0)` : `translateY(+120vh)`};
    } */
  }
  .month {
    text-transform: capitalize;
  }
  .lastKit {
    padding-top: 20px;
    span {
      color: #4e5464;
      font-family: 'Noto Sans Display',sans-serif;
      font-size: 14px;
      @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
        font-size: 13px;
      }
    }
  }
  .colored-text {
    line-height: normal;
    span {
      font-weight: 600;
      font-size: 16px;
    }
    .grey-color {
      color: #808080;
    }
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around !important;

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    width: 100%;
    .overflow {
      overflow: auto;
      padding-right: 10px;
    }
  }

  p {
    margin: 0;
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 13px;
    }
  }

  .data-div {
    padding-bottom: 20px;
  }

  .data-renovacao {
    color: #9800E0;
    padding-top: 20px;
    font-weight: 700;
    font-size: 14px;
    padding-bottom: 15px;
  }

  .blue-div {
    display: flex;
    background: #E5E9FE;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 8px;
    gap: 11px;
    align-items: center;

    span {
      color: #3F49B5;
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
      font-family: "Noto Sans Display", sans-serif;
    }

    svg path {
      stroke: #3F49B5;
    }

    .center {
      align-items: center;
      display: flex;
    }
  }

  .data {
    background: ${( { isCuradoria } ) => ( isCuradoria ? '#CEE9F2' : '#FCE2C3' )};
    border-radius: 20px;
    padding: 3px 10px;
    text-transform: capitalize;
    color: #343A4F;
    font-size: 14px;
  }

  .icon-paragraph {
    display: flex;
    align-items: center;
    gap: 15px;
    padding-top: 20px;
    
    svg {
      flex: 1;
      filter: ${( { isCuradoria } ) => isCuradoria
    ? 'invert(82%) sepia(37%) saturate(5000%) hue-rotate(148deg) brightness(94%) contrast(90%)'
    : 'invert(47%) sepia(98%) saturate(2200%) hue-rotate(12deg) brightness(104%) contrast(101%)'};
    }
    p {
      flex: 10;
    }
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      svg {
        flex: 1.5
      }
      p {
      flex: 10
    }
    }
  }
  .box-pending {
    line-height: 21px
    display: flex;
    padding-top: 20px;
    gap: 15px;
    color: #1f4fff;
    .icon-pending {
      display: flex;
      align-items: center;
      filter: invert(20%) sepia(98%) saturate(2596%) hue-rotate(226deg) brightness(104%) contrast(107%);
    }
  }

  .p-16 {
    font-weight: 600;
    font-size: 16px;
    padding-top: 15px;
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 15px;
    }
  }

  h1 {
  font-size: 18px;
  }

  .buttons-100 {
    button {
      width: 100%;
      margin-top: 30px;
    }
  }

  .buttons {
    padding-bottom: 20px;

    button {
      width: 192px;
      margin-bottom: 0;
      @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
        width: 140px;
        padding: 15px 0;
      }
    }
      padding-top: 40px;
      display: flex;
      justify-content: space-between;
    }
`

export const LoaderWrapper = styled.div`
  width: 50%;
  justify-content: center;
  display: flex;
  align-items: center;
  >div {
    border: 5px solid ${( { color } ) => color};
    border-left-color: #fff;
  }
`

export const InnerCard = styled.div`
  margin-top: 15px;
  border-radius: 10px;
  border: 1px solid #D4D4D4;
  padding: 15px;
`

export const SpanColor = styled.span`
  color: ${( { isCuradoria } ) => isCuradoria ? '#009BBF' : '#EB8100'};
`
